/* eslint-disable no-unused-vars */
import { Box, Button, IconButton, Switch, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const SwitchContainerStyled = styled('div')(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.3),
  width: '99.2vw',
  marginLeft: -120,
  height: 42,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingLeft: 120,
  color: theme.palette.global.gray,
  gap: 8,
  marginBottom: 25,
  [theme.breakpoints.up('sm')]: {
    width: '135%',
  },
  [theme.breakpoints.up('lg')]: {
    width: '122%',
  },
  [theme.breakpoints.up('xl')]: {
    width: '114.5%',
  },
}));

export const SwitchStyled = styled(Switch)(({ theme }) => ({
  width: 41,
  height: 21,
  padding: 0,
  borderRadius: 21,
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 16,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(21px)',
      color: alpha(theme.palette.secondary.main, 1),
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor:
          theme.palette.mode === 'dark'
            ? '#177ddc'
            : theme.palette.primary.main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 17,
    height: 17,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,.35)'
        : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export const TitleAndDeleteContainerStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 15,
});

export const DeleteDivStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 13,
  cursor: 'pointer',
  '&:hover': {
    color: alpha(theme.palette.global.lightgray, 0.9),
  },
}));

export const BoxesStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 19,
  marginBottom: '32px',
});

export const Box1Styled = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  padding: 24,
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
  display: 'flex',
  flexDirection: 'column',
  width: '60%',
  [theme.breakpoints.up('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.up('xl')]: {
    width: '60%',
  },
}));

export const IconStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 48,
  height: 48,
  borderRadius: 4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    fontSize: 20,
    color: theme.palette.global.white,
    transition: 'fontSize 0.2s',
    '&:hover': {
      fontSize: 32,
    },
  },
}));

export const DropzoneStyled = styled(Box)(({ theme }) => ({
  width: '84%',
  height: 48,
  border: `1px dashed ${theme.palette.global.gray}`,
  borderRadius: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: '#cccccccc',
  },
  '& p': {
    fontSize: 12,
  },
}));

export const LoadingDivStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

export const Box2Styled = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  width: '40%',
  padding: 24,
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
}));

export const AccordionStyled = styled(Box)({
  width: '100%',
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#f2f2f2',
  paddingLeft: 12,
  borderRadius: 4,
  margin: '1rem 0',
  boxShadow: '2px 2px 2px #ccc',
  cursor: 'pointer',
});

export const AccordionDisableStyled = styled(Box)({
  width: '100%',
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#f2f2f2cc',
  paddingLeft: 12,
  borderRadius: 4,
  marginTop: 32,
  marginBottom: '1em',
  boxShadow: '2px 2px 2px #ccc',
  cursor: 'not-allowed',
});

export const PlusBTNStyled = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.secondary.main,
  fontWeight: 600,
  marginLeft: 16,
  marginTop: 14,
}));

export const RemoveBTNStyled = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.secondary.main,
  fontWeight: 600,
  marginLeft: 16,
  marginTop: 14,
}));

export const LinksAndTotalStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  paddingRight: 5,
  marginTop: 32,
});

export const AttachmentsListStyled = styled(Box)({
  padding: '12px',
  backgroundColor: '#f2f2f2',
  margin: '10px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 48,
});

export const FileNameStyled = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const BtnSubmitStyled = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.global.white,
  fontWeight: 700,
  marginBottom: 76,
  height: 56,
  width: '39.5%',
}));
